<div class="container-fluid position-relative d-flex flex-column h-100" *ngIf="!isLoading">
  <div class="row flex-lg-grow-1 align-items-start">
    <!------------------  LEFT PART  ------------------>

    <div class="col-5 offset-1 px-4 mb-0 ">
      <mat-tab-group #matTabGroup (selectedIndexChange)="tabChanges($event)"
        animationDuration="0ms"
        class="far-border lf-tab my-4 sticky-top bg-white pt-3 sticky-left">
        <mat-tab label="Horaires"></mat-tab>
        <mat-tab label="Charges"></mat-tab>
        <mat-tab label="Caractéristiques"></mat-tab>
        <mat-tab label="F.A.Q"></mat-tab>
        <mat-tab label="Villes"></mat-tab>
      </mat-tab-group>

      <form (ngSubmit)="submit()" [formGroup]="scheduleForm" class="d-flex flex-column">
        <mat-accordion [multi]="true" class="info-accordion">

          <!--   Etat des lieux   -->
          <mat-expansion-panel [expanded]="true" class="px-0" hideToggle id="hours">
            <mat-expansion-panel-header class="px-0">
              <mat-panel-title> Horaires d'état des lieux</mat-panel-title>
            </mat-expansion-panel-header>
            <!--    @todo : optimiser - ngfor ?      -->
            <div class="d-flex flex-column gap-16">
              <div class="d-flex gap-16 align-items-center">
                <div class="w-35">Lundi</div>
                <mat-form-field>
                  <mat-label>Matin</mat-label>
                  <input formControlName="mondayAm" matInput pattern="^((?:[01]\d:[0-5][0-9]|2[0-3]:[0-5][0-9])(?:\s?)-(?:\s?)(?:[01]\d:[0-5][0-9]|2[0-3]:[0-5][0-9])(?:\s?,\s?)?)+$"
                    placeholder="08:30-12:00"
                    type="text">
                </mat-form-field>
                <mat-form-field>
                  <mat-label>Soir</mat-label>
                  <input formControlName="mondayPm" matInput pattern="^((?:[01]\d:[0-5][0-9]|2[0-3]:[0-5][0-9])(?:\s?)-(?:\s?)(?:[01]\d:[0-5][0-9]|2[0-3]:[0-5][0-9])(?:\s?,\s?)?)+$"
                    placeholder="14:30-19:00" type="text">
                </mat-form-field>
              </div>
              <div class="d-flex gap-16 align-items-center">
                <div class="w-35">Mardi</div>
                <mat-form-field>
                  <mat-label>Matin</mat-label>
                  <input formControlName="tuesdayAm" matInput pattern="^((?:[01]\d:[0-5][0-9]|2[0-3]:[0-5][0-9])(?:\s?)-(?:\s?)(?:[01]\d:[0-5][0-9]|2[0-3]:[0-5][0-9])(?:\s?,\s?)?)+$"
                    placeholder="08:30-12:00" type="text">
                </mat-form-field>
                <mat-form-field>
                  <mat-label>Soir</mat-label>
                  <input formControlName="tuesdayPm" matInput pattern="^((?:[01]\d:[0-5][0-9]|2[0-3]:[0-5][0-9])(?:\s?)-(?:\s?)(?:[01]\d:[0-5][0-9]|2[0-3]:[0-5][0-9])(?:\s?,\s?)?)+$"
                    placeholder="14:30-19:00" type="text">
                </mat-form-field>
              </div>
              <div class="d-flex gap-16 align-items-center">
                <div class="w-35">Mercredi</div>
                <mat-form-field>
                  <mat-label>Matin</mat-label>
                  <input formControlName="wednesdayAm" matInput pattern="^((?:[01]\d:[0-5][0-9]|2[0-3]:[0-5][0-9])(?:\s?)-(?:\s?)(?:[01]\d:[0-5][0-9]|2[0-3]:[0-5][0-9])(?:\s?,\s?)?)+$"
                    placeholder="08:30-12:00" type="text">
                </mat-form-field>
                <mat-form-field>
                  <mat-label>Soir</mat-label>
                  <input formControlName="wednesdayPm" matInput pattern="^((?:[01]\d:[0-5][0-9]|2[0-3]:[0-5][0-9])(?:\s?)-(?:\s?)(?:[01]\d:[0-5][0-9]|2[0-3]:[0-5][0-9])(?:\s?,\s?)?)+$"
                    placeholder="14:30-19:00" type="text">
                </mat-form-field>
              </div>
              <div class="d-flex gap-16 align-items-center">
                <div class="w-35">Jeudi</div>
                <mat-form-field>
                  <mat-label>Matin</mat-label>
                  <input formControlName="thursdayAm" matInput pattern="^((?:[01]\d:[0-5][0-9]|2[0-3]:[0-5][0-9])(?:\s?)-(?:\s?)(?:[01]\d:[0-5][0-9]|2[0-3]:[0-5][0-9])(?:\s?,\s?)?)+$"
                    placeholder="08:30-12:00" type="text">
                </mat-form-field>
                <mat-form-field>
                  <mat-label>Soir</mat-label>
                  <input formControlName="thursdayPm" matInput pattern="^((?:[01]\d:[0-5][0-9]|2[0-3]:[0-5][0-9])(?:\s?)-(?:\s?)(?:[01]\d:[0-5][0-9]|2[0-3]:[0-5][0-9])(?:\s?,\s?)?)+$"
                    placeholder="14:30-19:00" type="text">
                </mat-form-field>
              </div>
              <div class="d-flex gap-16 align-items-center">
                <div class="w-35">Vendredi</div>
                <mat-form-field>
                  <mat-label>Matin</mat-label>
                  <input formControlName="fridayAm" matInput pattern="^((?:[01]\d:[0-5][0-9]|2[0-3]:[0-5][0-9])(?:\s?)-(?:\s?)(?:[01]\d:[0-5][0-9]|2[0-3]:[0-5][0-9])(?:\s?,\s?)?)+$"
                    placeholder="08:30-12:00" type="text">
                </mat-form-field>
                <mat-form-field>
                  <mat-label>Soir</mat-label>
                  <input formControlName="fridayPm" matInput pattern="^((?:[01]\d:[0-5][0-9]|2[0-3]:[0-5][0-9])(?:\s?)-(?:\s?)(?:[01]\d:[0-5][0-9]|2[0-3]:[0-5][0-9])(?:\s?,\s?)?)+$"
                    placeholder="14:30-19:00" type="text">
                </mat-form-field>
              </div>
              <div class="d-flex gap-16 align-items-center">
                <div class="w-35">Samedi</div>
                <mat-form-field>
                  <mat-label>Matin</mat-label>
                  <input formControlName="saturdayAm" matInput pattern="^((?:[01]\d:[0-5][0-9]|2[0-3]:[0-5][0-9])(?:\s?)-(?:\s?)(?:[01]\d:[0-5][0-9]|2[0-3]:[0-5][0-9])(?:\s?,\s?)?)+$"
                    placeholder="08:30-12:00" type="text">
                </mat-form-field>
                <mat-form-field>
                  <mat-label>Soir</mat-label>
                  <input formControlName="saturdayPm" matInput pattern="^((?:[01]\d:[0-5][0-9]|2[0-3]:[0-5][0-9])(?:\s?)-(?:\s?)(?:[01]\d:[0-5][0-9]|2[0-3]:[0-5][0-9])(?:\s?,\s?)?)+$"
                    placeholder="14:30-19:00" type="text">
                </mat-form-field>
              </div>
              <div class="d-flex gap-16 align-items-center">
                <div class="w-35">Dimanche</div>
                <mat-form-field>
                  <mat-label>Matin</mat-label>
                  <input formControlName="sundayAm" matInput pattern="^((?:[01]\d:[0-5][0-9]|2[0-3]:[0-5][0-9])(?:\s?)-(?:\s?)(?:[01]\d:[0-5][0-9]|2[0-3]:[0-5][0-9])(?:\s?,\s?)?)+$"
                    placeholder="08:30-12:00" type="text">
                </mat-form-field>
                <mat-form-field>
                  <mat-label>Soir</mat-label>
                  <input formControlName="sundayPm" matInput pattern="^((?:[01]\d:[0-5][0-9]|2[0-3]:[0-5][0-9])(?:\s?)-(?:\s?)(?:[01]\d:[0-5][0-9]|2[0-3]:[0-5][0-9])(?:\s?,\s?)?)+$"
                    placeholder="14:30-19:00" type="text">
                </mat-form-field>
              </div>
            </div>

          </mat-expansion-panel>

          <!--   Charges   -->
          <mat-expansion-panel [expanded]="true" class="px-0" hideToggle id="charges">
            <mat-expansion-panel-header class="px-0">
              <mat-panel-title>Charges (à prévoir)</mat-panel-title>
              <mat-panel-description class="justify-content-end me-0 d-flex gap-16">

                <div class="d-flex gap-8 align-items-center">
                  <div class="rounded-circle bg-primary aspect-ratio_1-1"></div>
                  Inclut
                </div>
                <div class="d-flex gap-8 disabled align-items-center">
                  <div class="rounded-circle border aspect-ratio_1-1"></div>
                  Exclut
                </div>

              </mat-panel-description>
            </mat-expansion-panel-header>
            <div class="d-flex flex-wrap gap-24 mt-3 justify-content-between">
              <app-inclusions-management (itemChanged)="updateItemCharges($event, item)" *ngFor="let item of chargesArray" [item]="item"></app-inclusions-management>
            </div>
          </mat-expansion-panel>

          <!--   Caractéristiques   -->
          <mat-expansion-panel [expanded]="true" class="px-0" hideToggle id="caracteristics">
            <mat-expansion-panel-header class="px-0">
              <mat-panel-title>Caractéristiques</mat-panel-title>
            </mat-expansion-panel-header>

            <mat-accordion [multi]="true" class="info-accordion">
              <!--    Chambre amenities        -->
              <mat-expansion-panel [expanded]="true" class="px-0">
                <mat-expansion-panel-header class="ps-0 fw-normal">
                  <mat-panel-title>
                    De la chambre
                  </mat-panel-title>
                </mat-expansion-panel-header>
                <div class="d-flex justify-content-between row">
                  <ng-container *ngFor="let amenity of amenities">
                    <div *ngIf="amenity.type_id == 1 && amenity.status == 'Active'" class="col-6">
                      <label [ngClass]="{'text-primary': isChecked(selectedAmenities, amenity.id)}" class="pointer invisible_checkbox">
                        <input (click)="updateArray(selectedAmenities, amenity.id)" class="order-first pointer d-none" type="checkbox" value="">
                        <span class="material-icons font-18 v-middle me-1">{{amenity.symbol}}</span>
                        {{amenity.title}}
                      </label>
                    </div>
                  </ng-container>
                </div>

              </mat-expansion-panel>
              <!--    Shared amenities        -->
              <mat-expansion-panel [expanded]="true" class="px-0">
                <mat-expansion-panel-header class="ps-0 fw-normal">
                  <mat-panel-title>
                    De l'espace commun
                  </mat-panel-title>
                </mat-expansion-panel-header>
                <div class="d-flex justify-content-between row">
                  <ng-container *ngFor="let amenity of amenities">
                    <div *ngIf="amenity.type_id == 2 && amenity.status == 'Active'" class="col-6">
                      <label [ngClass]="{'text-primary': isChecked(selectedAmenities, amenity.id)}" class="pointer invisible_checkbox">
                        <input (click)="updateArray(selectedAmenities, amenity.id)" class="order-first pointer d-none" type="checkbox" value="">
                        <span class="material-icons font-18 v-middle me-1">{{amenity.symbol}}</span>
                        {{amenity.title}}
                      </label>
                    </div>
                  </ng-container>
                </div>

              </mat-expansion-panel>
            </mat-accordion>


          </mat-expansion-panel>

          <!--    FAQ  -->
          <mat-expansion-panel [expanded]="true" class="px-0" hideToggle id="faq">
            <mat-expansion-panel-header class="px-0">
              <mat-panel-title>Foire aux questions</mat-panel-title>
            </mat-expansion-panel-header>
            <mat-expansion-panel *ngFor="let faq of faqs" [expanded]="false" class="px-0">
              <mat-expansion-panel-header class="ps-0 fw-normal">
                <mat-panel-title>
                  <span class="bolder">{{ faq.name }}</span>
                </mat-panel-title>
              </mat-expansion-panel-header>
              <ng-container *ngIf="faq.content">
                <div (click)="updateArray(selectedFaqs, content.id)" *ngFor="let content of faq.content"
                  [ngClass]="{'text-primary': isChecked(selectedFaqs, content.id)}" class="my-1 light-grey pointer">
                  <span class="material-icons font-18 v-middle me-1">visibility</span> {{ content.name }}
                </div>
              </ng-container>
            </mat-expansion-panel>
          </mat-expansion-panel>


          <mat-accordion [multi]="true" class="info-accordion">
            <!--    Cities  -->
            <mat-expansion-panel [expanded]="true" class="px-0" hideToggle id="cities">
              <mat-expansion-panel-header class="px-0">
                <mat-panel-title class="title_3">Villes ({{ partner['cities'].length }})</mat-panel-title>
              </mat-expansion-panel-header>
              <!--    listing villes      -->
              <mat-accordion multi>

                <mat-expansion-panel *ngFor="let city of partner['cities']" class="mb-3" hideToggle>
                  <mat-expansion-panel-header class="px-0">
                    <mat-panel-title class="d-flex flex-column align-items-baseline">
                      <small class="light-grey d-block minitext_1">Métropole</small>
                      <span class="subtitle_2">
                     {{city.name}}
                        <small class="minitext_2 lightGray fst-italic">{{getTotalAccommodations(city.id)}}</small>
                  </span>

                    </mat-panel-title>
                    <mat-panel-description class="d-flex">
                      <div class="d-flex flex-column text-center flex-grow-1 subtitle_2">
                        <small class="light-grey minitext_1">Honoraires LF</small>
                        {{getConfig('citiesFees', city.id)}}
                      </div>
                      <div class="d-flex flex-column text-center subtitle_2">
                        <small class="light-grey minitext_1">Durée de séjour min. (mois)</small>
                        {{getConfig('cities', city.id)}}
                      </div>
                    </mat-panel-description>
                  </mat-expansion-panel-header>
                  <div *ngFor="let subCity of getSubCities(city.id)" class="d-flex gap-8 mt-3 w-100">
                    <div class="col-3 text_2 d-flex align-items-center me-2">
                      {{subCity.name}}
                      <small class="minitext_2 lightGray fst-italic ms-3">{{partner.cityCount[subCity.id]}}</small>
                    </div>

                    <div class="d-flex gap-4 justify-content-evenly me-4 col-9">
                      <mat-form-field class="w-25">
                        <input type="number" (change)="changeConfiguration('citiesFees',subCity.id, $event.target.value )" matInput [value]="partner.configuration.citiesFees[subCity.id]">
                      </mat-form-field>

                      <mat-form-field class="w-25">
                        <input type="number" (change)="changeConfiguration('cities',subCity.id, $event.target.value )" matInput [value]="partner.configuration.cities[subCity.id]">
                      </mat-form-field>
                    </div>

                  </div>
                </mat-expansion-panel>
              </mat-accordion>


            </mat-expansion-panel>
          </mat-accordion>
        </mat-accordion>

      </form>
      <div class="bg-white sticky-bottom position-sticky mt-auto pt-3 d-flex gap-3">
        <button type="submit" class="btn btn-primary w-100 fw-bold py-3" (click)="submit()" checkFormError [disabled]="isLoading">
          <span class="material-icons-outlined me-1 va-sub" *ngIf="!isLoading">download_done</span>
          <span *ngIf="isLoading" class="spinner-border spinner-border-sm v-middle me-1"></span>
          Enregistrer les modifications
        </button>
        <button class="btn btn-primary bottom_sticky position-sticky" (click)="openModale(confirmModal)" [disabled]="modaleStatus === 'submit'">
          <span *ngIf="modaleStatus === 'submit'" class="spinner-border spinner-border-sm v-middle me-1"></span>
          Mettre en ligne les changements
        </button>
      </div>
    </div>
    <!------------------  RIGHT PART  ------------------>
    <div class="offset-1 col-4 pt-3 sticky-top d-flex flex-column gap-24">
      <app-basic-informations *ngIf="partner" [type]="'partner'" [user]="partner"></app-basic-informations>


      <!--  informations spé   -->
      <div class="mt-auto">
        <p> Ajouté le
          <strong>{{ partner.created_at | date:'longDate':'':'FR' }}</strong>
        </p>
        <p> Dernière mis à jour le
          <strong>{{ partner.updated_at ? (partner.updated_at | date:'longDate':'':'FR') : 'date inconnue' }}</strong>
        </p>
        <p> Référent commercial
          <strong>{{ partner.contact_email ? partner.contact_email : 'Aucun référent assigné' }}</strong>
        </p>
      </div>
    </div>

  </div>
</div>


<!-------------------------------------------  loader ----------------------------------------->
<div class="flex-grow-1 d-flex align-items-center justify-content-center mb-5 h-100" *ngIf="isLoading">
  <div class="spinner-border text-primary"></div>
</div>


<ng-template #confirmModal let-modal>
  <div class="mt-3 px-4 d-flex align-items-center">
    <h5 class="title_1 m-0">Important</h5>
    <button type="button" class="btn border-0 m-0 ms-auto p-0" aria-label="Close" (click)="modal.dismiss(); modaleStatus = 'preSubmit'">
      <span class="material-icons-outlined text-black">close</span>
    </button>
  </div>

  <div class="pb-4 mt-2 px-4 pt-2">

    <ng-container *ngIf="modaleStatus === 'preSubmit'">
      <p>Vous vous apprêtez à mettre à jour <strong class="text-danger">tous les logements</strong> du partenaire.</p>
      <p>Vérifiez que vous avez fait toutes les modifications avant de valider.</p>

      <mat-checkbox [(ngModel)]="disabledWarningModale" class="mt-3">
        Ne plus me montrer cet avertissement.<br/>
        <small class="mediumGray minitext_2">(L'avertissement réapparaîtra au nettoyage des cookies)</small>
      </mat-checkbox>

      <button class="btn btn-primary mt-5 w-100" (click)="updatePartner()">
        Confirmer
      </button>
    </ng-container>

    <ng-container *ngIf="modaleStatus === 'submit'">
      <p>Les logements du partenaire sont en cours de mise à jour.</p>
      <p>Cette opération peut prendre quelques (courtes) minutes.</p>
      <p class="text-danger my-3 fw-bold">Si vous avez le temps de faire une partie candy crush, c'est que c'est (très
        certainement) buggé, criez plz</p>
    </ng-container>

    <ng-container *ngIf="modaleStatus === 'ended'">
      <p>Tous les logements ({{nbUpdated}}) ont été mis à jour.</p>
      <p></p>
      <button class="btn btn-secondary mt-3" role="button" (click)="modal.close(); modaleStatus = 'preSubmit'">
        Fermer
      </button>
    </ng-container>

  </div>
</ng-template>
